module.exports = __webpack_public_path__ + "static/media/messaging-search-highlight.7d6b1083.png";